<form [formGroup]="tadPropertyDetailsForm">
  <div class="row">
    <div class="col col-md-7 col-lg-6">
      <app-address [incomingAddress]="address" [addressLookUp]="tadPropertyDetailsForm.controls.addresslookup" (form_out)="handleIncomingForm($event)"></app-address>
    </div>
  </div>
  <div class="row">
    <div class="col-12 col-md-7 col-lg-6">
      @if (!isCommercialCase) {
        <div class="form-group">
          <label for="tadPropertyType">What type of property is it?</label>
          <select formControlName="tadPropertyType" class="form-control" id="tadPropertyType"
            [ngClass]="{'is-invalid': tadPropertyDetailsForm.get('tadPropertyType').touched && tadPropertyDetailsForm.get('tadPropertyType').invalid }">
            <option [value]="null">Please select</option>
            <option [value]="5">House - End terrace</option>
            <option [value]="6">House - Mid terrace</option>
            <option [value]="7">House - Semi Detached</option>
            <option [value]="8">House - Detached</option>
            <option [value]="9">Bungalow - Semi-Detached</option>
            <option [value]="10">Bungalow - Detached</option>
            <option [value]="11">Flat/Maisonette - converted</option>
            <option [value]="12">Flat/Maisonette - purpose built</option>
            <option [value]="17">Bungalow - End terrace</option>
            <option [value]="18">Bungalow - Mid Terrace</option>
            <option [value]="51">House in Multiple Occupation</option>
          </select>
          <together-auction-dip-validate-fields [displayError]="tadPropertyDetailsForm.get('tadPropertyType').touched && tadPropertyDetailsForm.get('tadPropertyType').hasError('required')"
          errorMsg="We need the property type."></together-auction-dip-validate-fields>
        </div>
      }

    </div>
  </div>
  @if (!isCommercialCase) {
    <div class="form-group">
      <label>Number of bedrooms</label>
      <div class="d-flex">
        <div class="c-incrementer">
          <button type="button" class="c-button c-button--icon-control" (click)="decrementBedrooms()">
            <span class="visually-hidden">Decrease value</span>
            <svg class="c-button__icon icon-minus" aria-hidden="true" focusable="false" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 4">
              <path fill="#fff" d="M0 0h24v4H0z" />
            </svg>
          </button>
          <input type="number" formControlName="tadPropertyNumberBedrooms"
            class="form-control c-incrementer__input text-center"
            [ngClass]="{'is-invalid': tadPropertyDetailsForm.get('tadPropertyNumberBedrooms').touched && tadPropertyDetailsForm.get('tadPropertyNumberBedrooms').invalid }"
            id="tad_number_bedrooms" min="1" max="10" size="2">
            <button type="button" class="c-button c-button--icon-control" (click)="incrementBedrooms()">
              <span class="visually-hidden">Increase value</span>
              <svg class="c-button__icon icon-plus" aria-hidden="true" focusable="false" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                <path fill="#fff" d="M24 10H14V0h-4v10H0v4h10v10h4V14h10v-4z" />
              </svg>
            </button>
          </div>
          <div>
            <together-auction-dip-tooltip [placement]="'top'" [title]="'This is the number of bedrooms the property has.'"></together-auction-dip-tooltip>
          </div>
        </div>
    <together-auction-dip-validate-fields [displayError]="tadPropertyDetailsForm.get('tadPropertyNumberBedrooms').touched && (tadPropertyDetailsForm.get('tadPropertyNumberBedrooms').hasError('required')
                || tadPropertyDetailsForm.get('tadPropertyNumberBedrooms').hasError('min'))" errorMsg="There must be at least 1 bedroom."></together-auction-dip-validate-fields>
        @if (tadPropertyDetailsForm.get('tadPropertyNumberBedrooms').hasError('max')) {
          <div class="row">
            <div class="col col-md-6">
              If your property has more than 10 bedrooms then please advise us when you speak to one of our staff and we will amend this
              number.
            </div>
          </div>
        }
      </div>
    }

    <div class="row">
      <div class="col col-md-7 col-lg-6">
        <fieldset class="form-group">
          <legend>Auction date (optional)</legend>
          <div class="d-flex">
            <div class="mr-1" [ngClass]="{'is-invalid': tadPropertyAuctionDay.dirty && tadPropertyAuctionDay.invalid,'is-valid': tadPropertyAuctionDay.dirty && tadPropertyAuctionDay.valid}">
              <label for="tadPropertyAuctionDay" class="visually-hidden">Day (DD)</label>
              <input type="number" class="form-control" [ngClass]="{'form-control-danger': tadPropertyAuctionDay.dirty && tadPropertyAuctionDay.invalid,'form-control-success': tadPropertyAuctionDay.dirty && tadPropertyAuctionDay.valid}"
                formControlName="tadPropertyAuctionDay" pattern="[0-9]{1,2}" title="You must provide a value between 1 and 31. (e.g. 10)"
                maxlength="2" placeholder="DD">
              </div>
              <div class="mr-1" [ngClass]="{'is-invalid': tadPropertyAuctionMonth.dirty && tadPropertyAuctionMonth.invalid,'is-valid': tadPropertyAuctionMonth.dirty && tadPropertyAuctionMonth.valid}">
                <label for="tadPropertyAuctionMonth" class="visually-hidden">Month (MM)</label>
                <input type="number" class="form-control" [ngClass]="{'form-control-danger': tadPropertyAuctionMonth.dirty && tadPropertyAuctionMonth.invalid,'form-control-success': tadPropertyAuctionMonth.dirty && tadPropertyAuctionMonth.valid}"
                  formControlName="tadPropertyAuctionMonth" pattern="[0-9]{1,2}" title="You must provide a value between 1 and 12. (e.g. 12)"
                  maxlength="2" placeholder="MM">
                </div>
                <div class="mr-2" [ngClass]="{'is-invalid': tadPropertyAuctionYear.dirty && tadPropertyAuctionYear.invalid,'is-valid': tadPropertyAuctionYear.dirty && tadPropertyAuctionYear.valid}">
                  <label for="tadPropertyAuctionYear" class="visually-hidden">Year (YYYY)</label>
                  <input type="number" class="form-control" [ngClass]="{'form-control-danger': tadPropertyAuctionYear.dirty && tadPropertyAuctionYear.invalid,'form-control-success': tadPropertyAuctionYear.dirty && tadPropertyAuctionYear.valid}"
                    formControlName="tadPropertyAuctionYear" pattern="[0-9]{4}" title="You must provide a valid 4-number year. (e.g. 2017)"
                    maxlength="4" placeholder="YYYY">
                  </div>
                  <div class="">
                    <together-auction-dip-tooltip [placement]="'top'" [title]="'This is the date of the auction the property is listed for.'"></together-auction-dip-tooltip>
                  </div>
                </div>
              </fieldset>
              @if (tadPropertyDetailsForm.hasError('fillInAllFields')) {
                <div class="d-flex invalid-feedback">
                  If you are adding in an auction date, please ensure you add all fields for the date.
                </div>
              }
              @if (tadPropertyDetailsForm.hasError('invalidDate')) {
                <div class="d-flex invalid-feedback">
                  The date entered is invalid, please enter a valid date.
                </div>
              }
              @if (tadPropertyDetailsForm.hasError('tooFarInFuture')) {
                <div class="d-flex invalid-feedback">
                  The date entered is too far in the future, auction dates beyond three months in the future are not allowed.
                </div>
              }
              @if (tadPropertyDetailsForm.hasError('tooFarInPast')) {
                <div class="d-flex invalid-feedback">
                  The date entered is too far in the past.
                </div>
              }
            </div>
          </div>
          <div class="row">
            <div class="col col-md-7 col-lg-6">
              <div class="form-group">
                <label for="tad_auction_house">Auction House (optional)</label>
                <div class="d-flex">
                  <div class="mr-2 w-100">
                    <input type="text" class="form-control" formControlName="tadPropertyAuctionHouse" id="tad_auction_house" aria-describedby="tad_auction_house_help"
                      placeholder="Name of auction house">
                    </div>
                    <div class="ml-auto">
                      <together-auction-dip-tooltip [placement]="'top'" [title]="'This is the auction house that has listed the property.'"></together-auction-dip-tooltip>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </form>
          <together-auction-dip-stage-select [forward_disabled]="tadPropertyDetailsForm.invalid" [forward_title]="isDipJourney ? 'Review your pre-approval' : 'Additional loan details'"
            [backward_title]="'Income details'" [show_action]="false" [show_forward]="true" [show_backward]="true" (on_forward)="onForwardClicked($event)"
            (on_backward)="onBackwardClicked($event)">
          </together-auction-dip-stage-select>
          <together-auction-dip-loading [is_loading]="isLoading"></together-auction-dip-loading>
